import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import Tracker from "@/components/site/Tracker";
import PublicHome from "@/pages/PublicHome";
import ArticlePage from "@/pages/ArticlePage";
import AuthorPage from "@/pages/AuthorPage";
import PolicyPage from "@/pages/PolicyPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import ArticlesList from "@/pages/admin/ArticlesList";
import ArticleEditor from "@/pages/admin/ArticleEditor";
import TeamManagement from "@/pages/admin/TeamManagement";
import FeedInbox from "@/pages/admin/FeedInbox";
import SettingsPage from "@/pages/admin/SettingsPage";
import EPaperAdmin from "@/pages/admin/EPaperAdmin";
import VideosAdmin from "@/pages/admin/VideosAdmin";
import EPaperPage from "@/pages/EPaperPage";
import CategoryPage from "@/pages/CategoryPage";
import SearchPage from "@/pages/SearchPage";

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Tracker />
          <Routes>
            <Route path="/" element={<PublicHome />} />
            <Route path="/news/:slug" element={<ArticlePage />} />
            <Route path="/author/:id" element={<AuthorPage />} />
            <Route path="/policy/:slug" element={<PolicyPage />} />
            <Route path="/epaper" element={<EPaperPage />} />
            <Route path="/category/:key" element={<CategoryPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/wp-admin" element={<AdminLogin />} />
            <Route path="/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="articles" element={<ArticlesList />} />
              <Route path="articles/new" element={<ArticleEditor />} />
              <Route path="articles/:id/edit" element={<ArticleEditor />} />
              <Route path="feeds" element={<FeedInbox />} />
              <Route path="team" element={<TeamManagement />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="epaper" element={<EPaperAdmin />} />
              <Route path="videos" element={<VideosAdmin />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
